<!-- 绑定模板 -->
<template>
  <div class="popup-main">
    <el-dialog
      :title="`绑定原料模板(已选${selfList.length})`"
      width="1200px"
      :visible.sync="selfShow"
      :close-on-click-modal="false"
    >
      <div>
        <vxe-grid size="mini" border :height="264" :data="noChooseList" :columns="showColumn">
          <!-- slot_header -->
          <template #header_input="{ column }">
            <c-table-header
              :title="column.title"
              :field="column.field"
              :url="headerFilterUrl"
              @change="headerFilterChange"
            />
          </template>

          <!-- slot_default -->
          <template #default_operate="{ row }">
            <el-link
              size="mini"
              type="success"
              icon="vxe-icon-lock-fill"
              title="绑定"
              @click="itemAdd(row)"
            >
              绑定
            </el-link>
          </template>
        </vxe-grid>
        <vxe-grid class="m-t-10" size="mini" :height="248" :data="selfList" :columns="activeColumn">
          <template #default_unit="{ rowIndex }">
            <el-link
              type="primary"
              style="display: block"
              :underline="false"
              @click="itemEditDanWeiZu(rowIndex)"
            >
              设置单位
            </el-link>
          </template>
          <template #default_set="{ row, rowIndex }">
            <el-link
              v-if="row.mo_ren_dan_wei_zu.includes('时间')"
              size="mini"
              type="primary"
              icon="vxe-icon-setting"
              title="设置产量"
              @click="itemSet(rowIndex)"
            >
              设置产量
            </el-link>
          </template>
          <template #default_operate="{ rowIndex }">
            <el-link
              size="mini"
              type="danger"
              icon="vxe-icon-unlock-fill"
              title="解绑"
              @click="itemDelete(rowIndex)"
            >
              解绑
            </el-link>
          </template>
        </vxe-grid>
      </div>

      <div slot="footer">
        <el-button size="mini" @click="popupCancel">取消</el-button>
        <el-button size="mini" type="primary" @click="popupConfirm">确认</el-button>
      </div>
    </el-dialog>

    <!-- 弹窗-设置单位 -->
    <PopupSetUnit
      v-if="isShowPopupSetUnit"
      :show.sync="isShowPopupSetUnit"
      :data.sync="selfList[activeMuBanIndex]"
    />

    <!-- 弹窗-设置价格 -->
    <PopupSetPrice
      v-if="isShowPopupSetPrice"
      :show.sync="isShowPopupSetPrice"
      :list="[selfList[activeMuBanIndex]]"
      type="产量"
      @success="setPriceSuccess"
    />
  </div>
</template>

<script>
import PopupSetUnit from '../../../goods/system/mu-ban/common/popup-set-unit'
import PopupSetPrice from '../../../goods/system/mu-ban/common/popup-set-price'
export default {
  components: {
    PopupSetUnit,
    PopupSetPrice
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      selfShow: false,
      selfList: {},
      allList: [],
      headerFilterUrl: '/admin/gcvip/muBan/searchHeard',
      filterData: {},
      showColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        { field: 'category1', title: '一级类目', slots: { header: 'header_input' } },
        { field: 'category2', title: '二级类目', slots: { header: 'header_input' } },
        { field: 'category3', title: '三级类目', slots: { header: 'header_input' } },
        { field: 'category4', title: '四级类目', slots: { header: 'header_input' } },
        {
          field: 'mu_ban_ming_cheng',
          title: '商品模板',
          width: 400,
          slots: { header: 'header_input' }
        },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      activeColumn: [
        {
          fixed: 'left',
          title: '序号',
          type: 'seq',
          width: 40
        },
        { field: 'category1', title: '一级类目' },
        { field: 'category2', title: '二级类目' },
        { field: 'category3', title: '三级类目' },
        { field: 'category4', title: '四级类目' },
        { field: 'mu_ban_ming_cheng', title: '商品模板', width: 240 },
        { title: '单位', width: 80, slots: { default: 'default_unit' } },
        { title: '产量', width: 80, slots: { default: 'default_set' } },
        { title: '操作', slots: { default: 'default_operate' } }
      ],
      isShowPopupSetUnit: false,
      isShowPopupSetPrice: false,
      activeMuBanIndex: ''
    }
  },
  computed: {
    // 未选择数据列表
    noChooseList() {
      let result = []
      this.allList.forEach((itemSt) => {
        let isNotRepect = this.selfList.every((itemNd) => {
          return itemSt.id !== itemNd.shang_pin_mu_ban_id
        })
        if (isNotRepect) result.push(this.$util.deepCopy(itemSt))
      })
      return result
    }
  },
  watch: {
    selfShow(val) {
      this.$emit('update:show', val)
    }
  },
  mounted() {
    this.selfShow = this.show
    this.selfList = this.$util.deepCopy(this.list)
    this.getMuBanAllList()
  },
  methods: {
    // 头部筛选更新
    headerFilterChange(obj) {
      this.filterData[obj.field] = obj.value
      this.getMuBanAllList()
    },
    // 获取所有模板
    getMuBanAllList() {
      this.$api({
        method: 'post',
        url: '/admin/gcvip/muBan/list',
        data: {
          currentPage: 1,
          pageSize: this.$constant.pageMax,
          bao_han: ['原料'],
          filterData: this.filterData,
          sortData: {
            id: 'desc'
          }
        }
      }).then((res) => {
        if (res.status === 200) {
          let result = res.data.page.list
          result.forEach((itemSt) => {
            itemSt.ji_chu_jia_ge = ''
            itemSt.ji_chu_chan_liang = ''
            itemSt.ji_chu_jia_ge_list = [
              [
                {
                  tiao_zheng_key_list: [], // 参数列表
                  tiao_zheng_scope_start: '', // 参数范围-开始
                  tiao_zheng_scope_end: '', // 参数范围-结束
                  tiao_zheng_scope_val: '', // 参数范围-匹配值
                  tiao_zheng_type: '', // 调整方式
                  tiao_zheng_val: '' // 调整值
                }
              ],
              [
                {
                  tiao_zheng_key_list: [], // 参数列表
                  tiao_zheng_scope_start: '', // 参数范围-开始
                  tiao_zheng_scope_end: '', // 参数范围-结束
                  tiao_zheng_scope_val: '', // 参数范围-匹配值
                  tiao_zheng_type: '', // 调整方式
                  tiao_zheng_val: '' // 调整值
                }
              ]
            ]
            itemSt.ji_chu_chan_liang_list = [
              [
                {
                  tiao_zheng_key_list: [], // 参数列表
                  tiao_zheng_scope_start: '', // 参数范围-开始
                  tiao_zheng_scope_end: '', // 参数范围-结束
                  tiao_zheng_scope_val: '', // 参数范围-匹配值
                  tiao_zheng_type: '', // 调整方式
                  tiao_zheng_val: '' // 调整值
                }
              ],
              [
                {
                  tiao_zheng_key_list: [], // 参数列表
                  tiao_zheng_scope_start: '', // 参数范围-开始
                  tiao_zheng_scope_end: '', // 参数范围-结束
                  tiao_zheng_scope_val: '', // 参数范围-匹配值
                  tiao_zheng_type: '', // 调整方式
                  tiao_zheng_val: '' // 调整值
                }
              ]
            ]

            let gongGongDanWeiIndex = -1
            itemSt.dan_wei_zu_list.forEach((itemNd, indexNd) => {
              if (itemNd.dan_wei_zu_name === '公共单位') gongGongDanWeiIndex = indexNd
              itemNd.dan_wei_list.forEach((itemRd) => {
                itemRd.is_mo_ren_dan_wei = false
              })
            })

            let shiJian = this.$util.deepCopy(this.$constant.shangPinShiJianUnitData)
            if (gongGongDanWeiIndex > -1) {
              itemSt.dan_wei_zu_list.splice(gongGongDanWeiIndex + 1, 0, shiJian)
            } else {
              itemSt.dan_wei_zu_list.unshift(shiJian)
            }

            itemSt.dan_wei_zu_list.forEach((itemNd) => {
              itemNd.dan_wei_list.forEach((itemRd) => {
                // 存储默认单位
                if (itemRd.is_mo_ren_dan_wei) {
                  itemSt.mo_ren_dan_wei_zu = `${itemRd.dan_wei_name},${itemNd.dan_wei_zu_name}`
                }
              })
            })
          })
          this.allList = res.data.page.list
        }
      })
    },
    // 项-绑定
    itemAdd(row) {
      let activeRow = this.$util.deepCopy(row)
      let result = {
        ...activeRow,
        id: '',
        shang_pin_mu_ban_id: activeRow.id
      }

      this.selfList.push(result)
    },
    // 项-解绑
    itemDelete(index) {
      this.selfList.splice(index, 1)
    },
    // 项-编辑单位组
    itemEditDanWeiZu(index) {
      this.activeMuBanIndex = index
      this.isShowPopupSetUnit = true
    },
    // 项-设置
    async itemSet(index) {
      this.activeMuBanIndex = index
      this.isShowPopupSetPrice = true
    },
    // 设置价格-成功
    setPriceSuccess(val) {
      this.selfList[this.activeMuBanIndex] = this.$util.deepCopy(val[0])
    },
    // 弹窗取消
    popupCancel() {
      this.selfShow = false
      this.$emit('update:show', false)
    },
    // 弹窗确认
    popupConfirm() {
      this.$emit('success', this.selfList)
      this.popupCancel()
    }
  }
}
</script>

<style lang="less" scoped>
.popup-main {
  /deep/ .el-link {
    vertical-align: inherit;
  }
}
</style>
